import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {SettlementsReportsService} from "../providers/settlements-reports.service";
import {SummarySettlementsDgSearchResults} from "../models/datagrid-search-results/summary-settlements.dg-search-results.model";
import {environment} from "../../environments/environment";

@Injectable()
export class SummarySettlementsResolve implements Resolve<SummarySettlementsDgSearchResults> {
  constructor(private settlementService: SettlementsReportsService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<SummarySettlementsDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    let queryParam = route.queryParams['reportNumber'];
    if (queryParam !== undefined) {
      let map = new Map<string, string>();
      map.set("reportNumber", queryParam);
      return this.settlementService.searchForResults( environment.DEFAULT_RESULTS_LIMIT, 0, map, 'ASC', 'created').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    } else {
      return this.settlementService.getResults( environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }
  }
}
